export interface AuthSession {
  readonly access_token: string;
  readonly expiration_time: number;
  readonly token_type: 'Bearer';
}
